import React, { useState } from 'react'
import { FormattedMessage } from 'react-intl'
import {Checkbox} from 'antd'
import apiClient from 'services/axios'
import update from 'immutability-helper'
import {Button, Spinner} from 'reactstrap'
import { ReactSortable } from 'react-sortablejs'
import { SortIcon } from 'config/icons'
import useTenant from 'components/platform/hooks/useTenant'
import { DIALOG_POSITION_CENTER, FluidDialog } from '../Dialog'
import { ConfirmModal } from '../Dialog/ConfirmModal'
import { FormattedMessageCustom } from '../app/FormattedMessageCustom'

const SearchSettings = ({
  onClose,
  fields: customizedFields,
  type,
  onSave,
  identifier,
  labelKey,
  labelTenantKey,
  renders,
  renderLabelProp,
  modalTitle = 'global.columns',
}) => {
  const [fields, setFields] = useState(customizedFields.sort((a, b) => a.position - b.position))
  const currentTenant = useTenant()
  const [isSaving, setIsSaving] = useState(false)

  const _onVisibleChange = (checked, index) => {
    const newFields = update(fields, {
      [index]: { $merge: { visible: checked } },
    })
    setFields(newFields)
  }

  const _save = () => {
    const customizationVars = fields.map((field, index) => {
      return {
        name: field[identifier],
        position: index,
        visible: !!field.visible,
      }
    })
    setIsSaving(true)
    apiClient
      .post('/api/customizations/user', {
        type,
        customizationVars,
      })
      .then(() => {
        setIsSaving(false)
        onClose()
        onSave()
      })
  }

  const customizationId = fields?.[0]?.customization

  // <pre>{JSON.stringify(this.state.fields,null,2)}</pre>
  //
  const header = (
    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
      <div>
        <FormattedMessage id={'global.customize'} />
        <br />
        <FormattedMessage id={modalTitle} />
      </div>
      <div>
        <Button onClick={onClose} color={'outline-primary'} className={'mr-2'}>
          <FormattedMessage id={'global.cancel'} />
        </Button>
        <Button color={'primary'} onClick={_save}>
          <FormattedMessage id={'marg_contr.applay'} />{isSaving && <Spinner size={'sm'} className={'ml-2'} />}
        </Button>
      </div>
    </div>
  )

  return (
    <FluidDialog
      onClose={onClose}
      title={'global.customize_columns'}
      dialogClass={'custom-topbar dialog-compact'}
      header={header}
      position={DIALOG_POSITION_CENTER}
      closeButton={false}
      opened
      draggable={false}
      modal
      width={340}
      maxHeight={720}
      offset={120}
      footer={
        customizationId && (
          <div
            style={{ padding: 8, borderTop: '1px solid #DDD', textAlign: 'center' }}
            onClick={() => {
              ConfirmModal({
                content: 'Ripristinare lo stato originale (default) delle Personalizzazioni',
                color: 'primary',
                width: 345,
                onOk: () => {
                  setIsSaving(true)
                  apiClient.delete(customizationId).then(() => {
                    setIsSaving(false)
                    onClose()
                    onSave()
                  })
                },
                okText: 'Ripristina',
                cancelText: 'Anulla',
              })
            }}
          >
            <div style={{ fontSize: 14, cursor: 'pointer' }} className={'link-item'}>
              <FormattedMessage id={'global.restore_default'} />
            </div>
          </div>
        )
      }
    >
      <ReactSortable
        style={{ padding: 10 }}
        list={fields}
        setList={setFields}
        draggable={'.draggable-option'}
      >
        {fields.map((field, index) => {
          const tenantLabel = currentTenant[field[labelTenantKey]] || null
          let labelId = field[labelKey] || null
          if (renderLabelProp) {
            labelId = renders[field[identifier]]?.props?.[renderLabelProp] || labelId
          }
          let label = labelId ? <FormattedMessageCustom id={labelId} /> : field.label

          if (!label) label = `Missing ${labelKey} 2 on "${field[identifier]}"`
          if (tenantLabel) label = tenantLabel
          if (field.finalTitle !== "") label = field.finalTitle || label
          return (
            <div
              className={field.customizable !== false ? 'draggable-option' : 'draggable-disabled'}
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                flexDirection: 'row',
                border: '1px solid #b8b8b8',
                borderRadius: 8,
                marginBottom: 8,
                padding: '4px 8px',
                lineHeight: '22px',
              }}
              key={field[identifier]}
            >
              <div>
                <Checkbox
                  disabled={field.customizable === false}
                  onChange={e => _onVisibleChange(e.target.checked, index)}
                  checked={field.visible}
                  className={'mr-2'}
                />
                {label}
              </div>
              <SortIcon style={{ fontSize: 20, color: '#000' }} />
            </div>
          )
        })}
      </ReactSortable>
    </FluidDialog>
  )
}

export default SearchSettings
